/**
 * @returns the given value after storing it in the given Map-based cache under
 * the given key.
 */
export const cacheAndReturn = <K, T>(cache: Map<K, T>, key: K, value: T): T => {
  cache.set(key, value);
  return value;
};
